/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyIntegratedToolAccount {
    getFixupPrototypeFunction() { return PolicyIntegratedToolAccount.fixupPrototype; }

    static newInstance(model: Partial<PolicyIntegratedToolAccount>): PolicyIntegratedToolAccount {
        let obj = Object.assign(new PolicyIntegratedToolAccount(), model);
        PolicyIntegratedToolAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyIntegratedToolAccount>): PolicyIntegratedToolAccount {
        if (!model) return null;
        return PolicyIntegratedToolAccount.newInstance(<PolicyIntegratedToolAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyIntegratedToolAccount) {
        if (!obj) return;

        models.PolicyIntegratedToolAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyIntegratedToolAccount): boolean {
        Object.setPrototypeOf(obj, PolicyIntegratedToolAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Identifier of the onboarded integrated tool account
     */
    id: string;

    /**
     * Service name of the integrated tool, e.g. ServiceNow
     */
    service_name: models.IntegratedToolName;

    /**
     * Service type of the integrated tool, e.g. ITSM
     */
    service_type: string;

}
